import { useStore } from './store.js';
import { WaitingRoom } from './components/WaitingRoom.js';
import { Game } from './components/Game.js';

export function App() {
  const { lobby, error, connection, dismissError } = useStore();

  return (
    <div className="app">
      {error && (
        <div className="toast" onClick={dismissError}>
          {error} <span className="toast-x">✕</span>
        </div>
      )}
      {!lobby ? (
        <div className="centered">
          <h1 className="logo">The Court of Shadows</h1>
          <p className="muted">
            {connection === 'closed' ? 'Reconnecting…' : 'Taking your seat at the table…'}
          </p>
        </div>
      ) : lobby.status === 'waiting' ? (
        <WaitingRoom />
      ) : (
        <Game />
      )}
    </div>
  );
}
